module.exports = __webpack_public_path__ + "img/imageleft@2x.99fe4583.png";